import {
  ButtonGroup,
  IconButton,
  IconCloseOutline,
  IconExpandOutline,
  IconCollapseOutline,
  IconGridOutline,
  Dialog,
} from '@zillow/constellation';
import React, { useState } from 'react';
import styled from 'styled-components';

const StyledDialog = styled(Dialog)<{ location: number; expanded: boolean }>`
  overflow-y: ${({ expanded }) => (expanded ? 'scroll' : 'hidden')};
  display: flex;
  position: fixed;
  max-height: calc(100vh - 16px);
  min-height: 340px;
  ${({ location, expanded }) => {
    switch (location) {
      case 0:
        return 'top: 123px;right:8px;' + (expanded ? 'top:8px;left: 8px;' : 'max-width: 70%;');
      case 1:
        return 'bottom: 8px;right:8px;' + (expanded ? 'left: 8px;' : 'max-width: 70%;');
      case 2:
        return 'bottom: 8px;left:8px;' + (expanded ? 'right: 8px;' : 'max-width: 70%;');
      case 3:
        return 'top: 123px;left:8px;' + (expanded ? 'top:8px;right: 8px;' : 'max-width: 70%;');
      default:
        return '';
    }
  }};
  z-index: 1000;
`;

const newDirection = ['down', 'left', 'up', 'right'];
interface IModileDialogProps {
  title: string;
  isOpen: boolean;
  onClose: () => void;
  Body: React.FC<{ dialogControls: React.ReactNode; expanded: boolean }>;
}
export const MobileDialog: React.FC<IModileDialogProps> = ({ title, Body, isOpen, onClose }) => {
  const [location, setLocation] = useState<number>(0);
  const rotateLocation = () => {
    // Rotate through 4 locations (each corner)
    setLocation((location + (expanded ? 2 : 1)) % 4);
  };
  const [expanded, setExpanded] = useState(false);

  return (
    <StyledDialog
      location={location}
      expanded={expanded}
      isOpen={isOpen}
      renderCloseButton={() => null}
      renderBody={() => (
        <Body
          dialogControls={
            <ButtonGroup conjoined aria-label={`${title} View Controls`}>
              <IconButton
                icon={<IconCloseOutline />}
                bare
                onClick={onClose}
                title={'Close'}
                size={'sm'}
                buttonType={'secondary'}
                data-test-id={`${title}-close-button`}
              />
              {!expanded && (
                <IconButton
                  icon={<IconExpandOutline />}
                  bare
                  title={`Expand ${title} List`}
                  onClick={() => setExpanded(!expanded)}
                  size={'sm'}
                  buttonType={'secondary'}
                  data-test-id={`${title}-expand-button`}
                />
              )}
              {expanded && (
                <IconButton
                  icon={<IconCollapseOutline />}
                  bare
                  title={`Collapse ${title} List`}
                  onClick={() => setExpanded(!expanded)}
                  size={'sm'}
                  buttonType={'secondary'}
                  data-test-id={`${title}-collapse-button`}
                />
              )}
              <IconButton
                icon={<IconGridOutline />}
                bare
                onClick={rotateLocation}
                title={`Move ${title} View ${newDirection[location]}`}
                size={'sm'}
                buttonType={'secondary'}
                data-test-id={`${title}-rotate-button-${location}`}
              />
            </ButtonGroup>
          }
          expanded={expanded}
        />
      )}
    />
  );
};
